module.exports = __webpack_public_path__ + "assets/img/one-tab9-on.ef3b6f08.png";